import { createAsyncThunk } from '@reduxjs/toolkit';
import { getEppDiameters } from 'application/components/api/EppDiameter';
import { selectComponentState } from 'projectRedux/store';

export const fetchAsyncEppDiameters = createAsyncThunk(
  'components/fetchAsyncEppDiameters',
  async (data: {}, thunkAPI) => {
    const response = await getEppDiameters();
    return response;
  },
  {
    condition(arg, thunkAPI) {
      return selectComponentState(thunkAPI.getState()).eppDiameters.loading === 'init';
    },
  }
);
